'use client';

import { FC } from 'react';
import { useRouter } from 'next/navigation';
import { logEvent } from '@/analytics';
import { ProfileSubtitle } from '@/layouts/Base/components/ProfileSubititle';
import { checkIsMobile } from '@/utils/device';
import { LoggedInUserDisplayWrapper } from './LoggedInUserDisplayWrapper';

export const VerifiedUserDisplay: FC = () => {
  const { push } = useRouter();
  const isMobile = checkIsMobile();

  const handleUserDisplayClick = () => {
    logEvent('PROFILE', {
      reference: document.title,
      platform: isMobile ? 'MOBILE' : 'WEB',
    });
    push('/profile');
  };

  return (
    <LoggedInUserDisplayWrapper
      id="home_click_profile"
      onClick={handleUserDisplayClick}
    >
      <ProfileSubtitle />
    </LoggedInUserDisplayWrapper>
  );
};
